<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const currentYear = new Date().getFullYear()
</script>

<template>
  <footer class="bg-white border-t-2 border-gray-300">
    <div class="max-w-7xl mx-auto px-4 py-4">
      <p class="text-sm text-gray-600 text-center">
        &copy; {{ currentYear }} sportovo.io. {{ t('footer.allRightsReserved') }}
      </p>
    </div>
  </footer>
</template>
